
export const STRATEGIES_CONNECT_CALL = {
    "RingingListening": function(message,that){
        if(that.sharedData.getDataPreviewPro().dialingMode === 1 && that.sharedData.getDoConnectCall() && that.props.preview.simultaneosRecs)
        {
            that.sharedData.setDoConnectCall(false)
            that.connectCall(message, that.sharedData.getParameters().UserID);
        }else{
            that.connectCall(message, that.sharedData.getParameters().UserID);
        }
    }

}


// WEBPACK FOOTER //
// ./src/js/Strategies/Strategies_Preview_ConnectCall.js